import { baseRequest } from '.'

export const googleOauth = async credential => {
  const res = await baseRequest.post(
    `/oauth/google/cb`,
    new URLSearchParams({
      credential,
    }),
    {
      headers: {
        Accept: 'application/vnd.api+json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  )
  return res
}

export const disconnectGoogleOauth = async () => {
  const res = await baseRequest.delete(`/oauth/google`)
  return res
}
